export const Props = Symbol('Props')
export const Comps = Symbol('Comps')
export const CompActionsSym = Symbol('CompActions')
export const StructureAPI = Symbol('StructureAPI')
